import BackendClient from './BackendClient'

class BackendAPI {
  client: BackendClient
  constructor(client: BackendClient) {
    this.client = client
  }
}

export default BackendAPI
